import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import middlewarePipeline from '@/_core/router/middlewarePipeline'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('@/views/sections/Courses.vue')
  },
  {
    path: '/catalog',
    name: 'Catalog',
    component: () => import('@/views/sections/Catalog.vue')
  },
  {
    path: '/catalog/:id',
    name: 'Product',
    props: route => ({ productId: Number(route.params.id) }),
    component: () => import('@/views/sections/Product.vue')
  },
  {
    path: '/tariffs',
    name: 'Tariffs',
    component: () => import('@/views/sections/Tariffs.vue')
  },
  {
    path: '/tariffs/:id',
    name: 'Tariff',
    props: route => ({ productId: Number(route.params.id) }),
    component: () => import('@/views/sections/Tariff.vue')
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import('@/views/sections/Faq.vue')
  },
  {
    path: '/other',
    name: 'Other',
    component: () => import('@/views/sections/Other.vue')
  },
  {
    path: '/:notFound(.*)',
    name: 'NotFound',
    component: () => import('@/views/NotFound'),
    meta: {
      title: '404'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from) {
    if (to.name !== from.name) document.getElementById('app').scrollIntoView()
  }
})

router.beforeEach((to, from, next) => {
  let middleware = []
  if (to.meta.middleware) middleware = middleware.concat(Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware])
  if (!middleware.length) return next()

  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    nextMiddleware: middlewarePipeline(context, middleware, 1)
  })
})

export default router
